import {
    REQUEST_EVENT_ACTIVITY_LOGS,
    RECEIVE_EVENT_ACTIVITY_LOGS,
    RECEIVE_EVENT_ACTIVITY_LOGS_ERROR,
} from '../actions/eventActivityLogs';

const initialState = {
    logs: {},
};

export default function eventActivityLogs(state = initialState, action) {
    // Normalize eventId to string for consistent object key lookup
    const eventId = action.eventId ? String(action.eventId) : null;

    switch (action.type) {
        case REQUEST_EVENT_ACTIVITY_LOGS: {
            if (!eventId) return state;

            return {
                ...state,
                logs: {
                    ...state.logs,
                    [eventId]: {
                        ...state.logs[eventId],
                        loading: true,
                        error: null,
                    },
                },
            };
        }

        case RECEIVE_EVENT_ACTIVITY_LOGS: {
            if (!eventId) return state;

            const existingLogs = state.logs[eventId]?.items || [];
            // Convert page to number for comparison (API should return int, but handle string case)
            const currentPage = Number(action.data.meta?.page) || 1;
            const isAppending = currentPage > 1 && existingLogs.length > 0;

            return {
                ...state,
                logs: {
                    ...state.logs,
                    [eventId]: {
                        items: isAppending ? [...existingLogs, ...action.data.items] : action.data.items,
                        meta: action.data.meta,
                        loading: false,
                        error: null,
                    },
                },
            };
        }

        case RECEIVE_EVENT_ACTIVITY_LOGS_ERROR: {
            if (!eventId) return state;

            return {
                ...state,
                logs: {
                    ...state.logs,
                    [eventId]: {
                        ...state.logs[eventId],
                        loading: false,
                        error: action.error,
                    },
                },
            };
        }

        default:
            return state;
    }
}
